import { render, staticRenderFns } from "./CoBugReportButton.vue?vue&type=template&id=33e2f7d8&"
import script from "./CoBugReportButton.vue?vue&type=script&lang=js&"
export * from "./CoBugReportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports